/** 家属端 Tab 与返回导航 */

export function buildFamilyTabQuery(tab, orderFilter) {
  const query = {};
  if (tab && tab !== "home") {
    query.tab = tab;
  }
  if (tab === "orders" && orderFilter && orderFilter !== "all") {
    query.filter = orderFilter;
  }
  return query;
}

export function familySubRouteQuery(fromTab, orderFilter) {
  const q = { fromTab: fromTab || "home" };
  if (fromTab === "orders" && orderFilter && orderFilter !== "all") {
    q.orderFilter = orderFilter;
  }
  return q;
}

export function familyGoBack(router, route, defaultTab = "home") {
  const fromTab = (route && route.query && route.query.fromTab) || defaultTab;
  const orderFilter = route && route.query && route.query.orderFilter;
  const query = buildFamilyTabQuery(fromTab, orderFilter);
  query._t = String(Date.now());
  router.replace({
    path: "/family",
    query,
  });
}
